import styled from "styled-components";
import { WrapperContainer } from "../../components";
import { colors } from "../../consts";

export const HeadingContainer = styled(WrapperContainer)`
  width: 100%;
  height: 70px;
  border-bottom: 1px solid;
  border-color: ${colors.RAISIN_10};

  padding: 24px;
`;

export const MainWrapper = styled(WrapperContainer)`
  width: 100%;
  height: calc(100% - 70px);
`;

export const LeftContainer = styled(WrapperContainer)`
  width: 35%;
  height: 100%;
  max-width: 250px;
  min-width: 200px;
  border-right: 1px solid;
  border-color: ${colors.RAISIN_10};

  overflow-x: hidden;
  overflow-y: auto;

  padding: 24px;
`;

export const MainContainer = styled(WrapperContainer)`
  width: 100%;
  height: ${(props) => (props?.hasBottomContent ? "calc(100% - 96px)" : "100%")};

  padding: 24px;
  overflow-y: auto;
  margin-right: 4px;
`;

export const BottomContainer = styled(WrapperContainer)`
  width: 100%;
  height: 96px;

  border-top: 1px solid;
  border-color: ${colors.RAISIN_10};

  padding: 24px;
`;
